import { connect, useSelector } from 'react-redux'
import { localize } from 'store/modules/localization'

const createLocalizationInfo = (localization) => ({
  language: localization.language,
  locale: localization.locale,
  localize: (key) => localize(localization, key)
})
export const useLocalization = () => {
  const localization = useSelector(state => state.localization)
  return createLocalizationInfo(localization)
}
export const localized = (component) =>
  connect(({ localization }) => createLocalizationInfo(localization))(component)
